import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
    IParams,
    RedirectParamsHistorical,
} from '../../../../shared/types/redirectParams';
import { FormikProps } from 'formik';
import { REDIRECTLIST, REDIRECT_DETAIL } from '../../../../routes/paths';
import {
    asyncGetParam,
    asyncPostParam,
    asyncGetRedirectParamHistorical,
    asyncPatchtRedirectPersonParam,
} from '../../../../services/param.service';
import { ToastSwal } from '../../../components/general/toastSwals/toastSwal';
import { ISelect } from '../../../../shared/types/shared';

export const useRedirectPqrForm = (showHistorical: boolean) => {
    const navigate = useNavigate();
    const { idRedirect } = useParams();
    const [redirect, setRedirect] = useState<IParams>();
    const [loading, setLoading] = useState(false);
    const [formikRedirectData, setormikRedirectData] =
        useState<FormikProps<IParams>>();

    const [redirectHistorical, setRedirectHistorical] =
        useState<RedirectParamsHistorical[]>();
    const isValidForm = formikRedirectData?.isValid;

    const handleCleanAndBack = () => {
        formikRedirectData?.resetForm();
        navigate(`${REDIRECT_DETAIL}/${idRedirect}`);
    };

    const handleSubmit = async () => {
        await formikRedirectData?.submitForm();

        if (!isValidForm) return;

        setLoading(true);

        const data: IParams = formikRedirectData?.values as IParams;

        let res: any | undefined = undefined;

        try {
            if (redirect && redirect.id)
                res = await asyncPatchtRedirectPersonParam(redirect.id, data);
            else res = await asyncPostParam(data);
        } catch (error) {}

        if (res?.items) {
            ToastSwal.fire({
                text: `¡Felicidades! La persona se ${
                    redirect && redirect.id ? 'actualizo' : 'creó'
                } satisfactoriamente.`,
                icon: 'success',
                timer: 5000,
                position: 'center-end',
            });
            navigate(`${REDIRECT_DETAIL}/${res?.items?.id}`);
        } else {
            const message = `Lo sentimos, no se pudo 
                ${redirect && redirect.id ? 'actualizar' : 'crear'}
                la persona. Por favor, asegúrate de ${
    res?.message !== 'PARAM-FAIL-DUPLICATED'
        ? 'diligenciar los datos correctamente'
        : 'que no exista previamente'
} e intenta nuevamente más tarde.`;

            ToastSwal.fire({
                text: message,
                icon: 'error',
                timer: 5000,
                position: 'center-end',
            });
        }

        setLoading(false);
    };

    useEffect(() => {
        if (Boolean(idRedirect?.trim())) {
            setLoading(true);
            asyncGetParam(idRedirect?.trim())
                .then((redirect: any) => {
                    if (!redirect || !redirect.items) navigate(REDIRECTLIST);

                    [redirect?.parent].forEach((item: any) => {
                        if (item)
                            Object.keys(item).forEach((key) => {
                                if (item?.[key] && (item?.[key] as ISelect)?.id)
                                    item[key] = (
                                        item[key] as ISelect
                                    )?.id.toString();
                            });
                    });

                    setRedirect(redirect?.items);
                })
                .finally(() => setLoading(false));
        }
    }, [idRedirect]);

    useEffect(() => {
        if (Boolean(idRedirect?.trim()) && showHistorical) {
            setLoading(true);

            asyncGetRedirectParamHistorical(idRedirect?.trim())
                .then((resp) => {
                    if (resp) setRedirectHistorical(resp);
                    else navigate(REDIRECTLIST);
                })
                .finally(() => setLoading(false));
        }
    }, [idRedirect, showHistorical]);

    return {
        redirect,
        loading,
        isValidForm,
        handleSubmit,
        handleCleanAndBack,
        setormikRedirectData,
        redirectHistorical,
    };
};
